// extracted by css-extract-rspack-plugin
export default {"picker":"VMRXONFWvl4Z_lPQ"};